import utils from '@/helpers/utils/index.js'

export default {
  loadingProcesses (state) {
    if (!utils.count(state.processes)) return false
    let currentProcess = {}
    let key = Object.keys(state.processes)[0]
    currentProcess = state.processes[key]
    if (!currentProcess.message) currentProcess.message = 'Loading'
    return currentProcess
  }
}
